export default "/images/share-mobile.svg?b19e7e80915d9779592a5c8b73e79cd1";